import FormulateCssClassService from '@/Services/FormulateCssClassService/FormulateCssClassService';

class WrapperCssClassService extends FormulateCssClassService {
    public process(): void {
        if(!this.isButton()) {
            if(this.isBox()) {
                this.addGroupedClass([
                    'flex',
                    'items-center'
                ])
            }
        }
    }
}

export default WrapperCssClassService
